import { Checkbox, Form, Input } from "antd";
import React from "react";
import { cardioCongenitalOptions } from "../OpPhysioOptions";
import DynamicInputFields from "../../../../../blocks/FormItems/DynamicInputFields";

const CongenitalDisorders = ({ form, onSync }) => {
  const congenitalValues = Form.useWatch("congenital_disorders", form);
  const showOther = congenitalValues?.includes("cardio_congenital_options");

  const handleChange = (checkedValues) => {
    form.setFieldValue("congenital_disorders", checkedValues);

    if (checkedValues.includes("cardio_congenital_options")) {
      const existing = form.getFieldValue("congenital_disorders_other");
      if (!Array.isArray(existing) || existing.length === 0) {
        form.setFieldValue("congenital_disorders_other", [{ remarks: "" }]);
      }
    } else {
      form.setFieldValue("congenital_disorders_other", []);
    }
    onSync?.();
  };

  return (
    <>
      <Form.Item label="Congenital Disorders" name="congenital_disorders">
        <Checkbox.Group
          options={cardioCongenitalOptions}
          onChange={handleChange}
        />
      </Form.Item>

      {showOther && (
        <DynamicInputFields
          form={form}
          field_key="congenital_disorders_other"
          inputStyle={{ width: "60%" }}
          formStyle={{ marginBottom: 8 }}
        />
      )}

      <Form.Item name="congenital_disorders_comments">
        <Input.TextArea
          rows={2}
          placeholder="Comments"
          style={{ width: "60%" }}
        />
      </Form.Item>
    </>
  );
};

export default CongenitalDisorders;
